// @ts-nocheck
import React from 'react';
import { styled } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from "@mui/material/Button";
import LogoutIcon from '@mui/icons-material/Logout';
import KeyCloak from "../Auth/Keycloak";
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useAuth } from "../Auth/State/AuthContext";

// Styled components
const AppBarStyled = styled(AppBar)(({ theme }) => ({
    zIndex: 1300,
    [theme.breakpoints.down('md')]: {
        zIndex: 1301,
    },
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
}));

const RootTypography = styled(Typography)(({ theme }) => ({
    fontWeight: '600',
    display: "flex",
    width: "90%",
}));

const LoginButton = styled(Button)(({ theme }) => ({
    whiteSpace: 'nowrap',
    textTransform: 'none',
    fontSize: '120%',
    "& .MuiButton-endIcon": {
        [theme.breakpoints.down('md')]: {
            marginRight: '10px',
        },
    },
    "& .MuiButton-endIcon svg": {
        fontSize: '25px',
        paddingBottom: '4px',
    },
}));

export default function Header({ error, toggleDrawer }) {
    const { impersonado, unImpersonate } = useAuth();
    const matches = useMediaQuery('(min-width:600px)');

    const redirectTo = !error ? KeyCloak.isLoggedIn() ? impersonado ? unImpersonate : KeyCloak.doLogout : KeyCloak.doFirstLogin : null;

    return (
        <div>
            <AppBarStyled color='primary' position="fixed">
                <Toolbar>
                    {!error ? KeyCloak.isLoggedIn() ? (
                        <IconButton
                            size="large"
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            sx={{ display: { sm: 'none', xs: 'block' }, mr: 1 }}
                            onClick={() => toggleDrawer()}
                        >
                            <MenuIcon />
                        </IconButton>
                    ) : null : null}
                    <RootTypography variant="h6" noWrap>
                        {!matches ? "SIA" : "Sistema Integrado de Aplicaciones"}
                    </RootTypography>
                    {!error ? (
                        <LoginButton
                            color="inherit"
                            endIcon={KeyCloak.isLoggedIn() ? <LogoutIcon /> : <PersonAddAltOutlinedIcon />}
                            onClick={redirectTo}
                            variant='text'
                            sx={{ mr: 1 }}
                        >
                            {KeyCloak.isLoggedIn() ? impersonado ? "Dejar de Impersonar" : "Cerrar Sesión" : "Iniciar Sesión"}
                        </LoginButton>
                    ) : ""}
                </Toolbar>
            </AppBarStyled>
        </div>
    );
}
